import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { DialogService } from 'src/app/_services/dialog.service';
import { LoadingService } from 'src/app/_services/loading.service';

import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {

  headerColor = 'primary';
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches));

  constructor(public authService: AuthService,
    private dialogService: DialogService,
    private loading: LoadingService,
    private router: Router,
    private breakpointObserver: BreakpointObserver
  ) { }

  ngOnInit() {
    this.isLoggedInn();
  }

  logout() {
    this.dialogService.openConfirmDialog('Are you sure want to logout?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.loading.spin$.next(true);
          this.authService.logout().subscribe(data => {
            //console.log(data);
            if (JSON.stringify(data['status']) == 'true') {
              localStorage.removeItem('dschool_id_token');
              this.authService.isLogin = false;
              this.authService.user_dept = null;
              this.loading.spin$.next(false);
              this.router.navigate(['/login']);
            }
          });
        }
      });
  }

  isLoggedInn() {
    if (this.authService.isLoggedIn()) {
      this.loading.spin$.next(false);
      this.authService.validate_token().subscribe(data => {
        //console.log(data);
        if (data['status']) {
          this.authService.bindNavbar(data['user']);
          this.authService.isLogin = true;
          this.router.navigateByUrl('/ecom/orders');
          this.loading.spin$.next(false);
        }
        else {
          localStorage.removeItem('dschool_id_token');
          this.router.navigateByUrl('/login');
          this.loading.spin$.next(false);
        }
      });
    }
    else {
      var connection = this.authService.connect_to_server().subscribe(data => {
        console.log(data);
      });
      this.router.navigateByUrl('/login');
    }
  }



}
